import { render, staticRenderFns } from "./AppIframe2.vue?vue&type=template&id=9ce09f8a&scoped=true"
import script from "./AppIframe2.vue?vue&type=script&lang=js"
export * from "./AppIframe2.vue?vue&type=script&lang=js"
import style0 from "./AppIframe2.vue?vue&type=style&index=0&id=9ce09f8a&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce09f8a",
  null
  
)

export default component.exports